import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, normalizeStyle as _normalizeStyle, Transition as _Transition, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "placeholder" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 0,
  class: "on-mobile",
  style: {"height":"48px","flex-shrink":"0"}
}
const _hoisted_4 = { key: 0 }

import { CSSProperties, ref, watch } from 'vue';
import { useKeyDownStore } from '@/stores/key-down';
import DownArrow from '@/components/icons/navigation/DownArrowIcon.vue'
import { useEventListener, useResizeObserver } from '@vueuse/core';
import VButton from './VButton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'VSelect',
  props: {
    placeholder: null,
    items: null,
    modelValue: null,
    small: { type: Boolean },
    placement: null,
    menuClass: null,
    mobileClose: { type: Boolean },
    selectedValue: null
  },
  emits: ['update:modelValue', 'open', 'close'],
  setup(__props: any, { expose, emit }) {

const props = __props as { 
  placeholder?: string, 
  items?: any[], 
  modelValue?: string | null, 
  small?: boolean,
  placement?: "start" | "end",
  menuClass?: string,
  mobileClose?: boolean,
  selectedValue?: number
}




const opened = ref(false)
const style = ref<CSSProperties>({})
let el: HTMLElement | null = null

const open = (e: MouseEvent) => {
  el = e.currentTarget as HTMLElement
  attachObject()
  opened.value = true
  y.value = 0
  emit("open")
}

const preventClose = () => {
  opened.value = true
}

const close = (reason: string = "") => {
  opened.value = false
  emit("close", reason)
}

const selectItem = (item: any) => {
  emit("update:modelValue", item.id)
  close()
}

useKeyDownStore().watch("Escape", () => opened.value, close)

const onMenuClick = (e: MouseEvent) => {
  const target = e.target as HTMLElement
  // if (target.tagName === "BUTTON" || target.parentElement?.tagName === "BUTTON") {
  //   close()
  // }
}

const windowSize = { width: window.innerWidth, height: window.innerHeight }
const attachObject = async () => {
  if (!el || !opened.value) return
  const rect = el.getBoundingClientRect()
  let top = rect.bottom + 8
  let left = props.placement !== "end"? rect.left: undefined
  let right = props.placement === "end"? (windowSize.width - rect.right): undefined

  if (menuRef.value) {
    if (top + menuRef.value.clientHeight > windowSize.height-10) {
      top = windowSize.height- 10 - menuRef.value.clientHeight
    }

    if (typeof left === "number" && left + menuRef.value.clientWidth > windowSize.width-10) {
      left = windowSize.width - 10 - menuRef.value.clientWidth
    }
    if (typeof right === "number" && right + menuRef.value.clientWidth > windowSize.width-10) {
      right = windowSize.width - 10 - menuRef.value.clientWidth
    }
  }

  const f = (val: number) => Math.round(val/2)*2

  style.value = { top: f(top) + "px", right: right? f(right) + "px": "auto", left: left? f(left) + "px": "auto", minWidth: rect.width+"px" }
}

window.addEventListener("resize", () => {
  windowSize.width = window.innerWidth
  windowSize.height = window.innerHeight
  attachObject()
})

const menuRef = ref<HTMLElement>()
useResizeObserver(menuRef, (res) => {
  attachObject()
})

expose({
  open,
  close,
  preventClose
})

const y = ref(0)
useEventListener(menuRef, "scroll", (e) => {
  y.value = (e.target as HTMLElement).scrollTop
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", _mergeProps(_ctx.$attrs, {
      class: ["v-select", { opened: opened.value, small: props.small }],
      onClick: open
    }), [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createElementVNode("span", _hoisted_1, _toDisplayString(props.placeholder), 1)
      ]),
      _createVNode(DownArrow, { class: "v-select__arrow" })
    ], 16),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (opened.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "v-select-backdrop",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (close()))
          }))
        : _createCommentVNode("", true),
      _createVNode(_Transition, { name: "grow" }, {
        default: _withCtx(() => [
          (opened.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["v-select-menu origin-top-center scroll", __props.menuClass]),
                style: _normalizeStyle(style.value),
                ref_key: "menuRef",
                ref: menuRef,
                onClick: onMenuClick
              }, [
                _renderSlot(_ctx.$slots, "top"),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.items, (item) => {
                  return (_openBlock(), _createElementBlock("button", {
                    class: _normalizeClass(["v-select-menu__button", { selected: item.id === props.modelValue }]),
                    onClick: ($event: any) => (selectItem(item))
                  }, [
                    (item.icon)
                      ? (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), { key: 0 }))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(item.name || item.title), 1)
                  ], 10, _hoisted_2))
                }), 256)),
                (props.mobileClose)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3))
                  : _createCommentVNode("", true),
                (props.mobileClose)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "v-select__actions on-mobile",
                      style: _normalizeStyle({ bottom: -y.value + 'px' })
                    }, [
                      (typeof props.selectedValue === 'number')
                        ? (_openBlock(), _createBlock(VButton, {
                            key: 0,
                            onClick: close
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Apply"),
                              (props.selectedValue > 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(props.selectedValue), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(VButton, {
                        secondary: "",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (close('cancel')))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Cancel")
                        ]),
                        _: 1
                      })
                    ], 4))
                  : _createCommentVNode("", true)
              ], 6))
            : _createCommentVNode("", true)
        ]),
        _: 3
      })
    ]))
  ], 64))
}
}

})